import { ICompetitionRanking, ICompetitionRankingList } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidCompetitionRanking } from './typeguards';
import { CreateCompetitionRankingInputSchema, CompetitionRankingRankingList as IRanking} from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { CompetitionRankingQuery } from '../types';
import { isNotEmptyArray } from '@sky-it-livedata-libraries/livedata-commons';
import { isNotNull } from '../../../utils/tests';

export default (obj: CompetitionRankingQuery): ICompetitionRanking=> {
  if (isValidCompetitionRanking(obj)) {
    CreateCompetitionRankingInputSchema().parse(obj.data.getCompetitionRanking, {reportInput: true});

      const competitionRanking = obj.data.getCompetitionRanking?.rankingLists ?? [];
      const rankingLists: ICompetitionRankingList[] = (competitionRanking as IRanking[]).reduce((acc: ICompetitionRankingList[], ranking: IRanking) => {
        const { competitionId, customCompetitionName = '', seasonId, groups = [] } = ranking;
        const items = (groups && groups.length) ? groups!.map((group) => ({
          competitionId,
          customCompetitionName,
          seasonId,
          roundName: isNotEmptyArray(group!.teams) ? (group!.roundName ?? 'unico') : 'unico',
          teams: isNotEmptyArray(group!.teams) ? (group!.teams ?? []).filter(isNotNull) : [],
        })) as ICompetitionRankingList[] : [];
        acc.push(...items);
        return acc;
      }, []);

    return { rankingLists } as ICompetitionRanking;
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in CompetitionRankingQuery object',
      data: obj
    });
  }
};
